import { render } from "./aboutLisaSuites.vue?vue&type=template&id=0e6a6c01"
import script from "./aboutLisaSuites.vue?vue&type=script&lang=js"
export * from "./aboutLisaSuites.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__